<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Select Package</h6>
             </div>
            
         </div>
         <!-- Start All Language List Table -->
         <div class="p-3 sm:p-4">
            <div class="flex flex-wrap gap-4 overflow-x-auto scrollbar-table">
                <div 
                    class="bg-white dark:bg-dark-bg rounded-lg shadow-md overflow-hidden w-72" 
                    v-for="(item, index) in packageList" 
                    :key="item.id"
                >
                    <div class="p-4">
                        <h3 class="font-semibold text-lg text-gray-700 dark:text-dark-text">{{ item.name }}</h3>
                        <p class="text-gray-500 dark:text-dark-secondary">Rate: {{ item.cost }}</p>
                        <p class="text-gray-500 dark:text-dark-secondary">Status: {{ item.status }}</p>
                    </div>
                    <div class="flex justify-center p-4 border-t border-gray-200 dark:border-dark-border">
                        <button 
                            class="btn-select" 
                            @click="selectPackage(item)"
                        >
                            Select
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        
         <!-- End All Language List Table -->
     </div>
 </div>
</template>


<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import axios from 'axios';
    
    export default {
    name: 'ProductCategory',
    components: {
     
    } ,
    mounted(){
     this.getBasics();
    },
    data() {
     return {
         isAdd:0,
         isEdit:0,
         isDelete: 0,
         deleteId:0,
         packageList:[],
         packages:{
            name:'',
            cost:'',
            descrption:'',
            days:'',
            status:'',
    
         }
        //  cat:{name:'',status:'Active'},
        //  employees: {empname:'',emprole:'0',isMainAdmin:0},
     }
     }, 
    methods:{
     closeModal(){
        // $('#editModal').modal('hide');
             $("#editModal").addClass('hidden');
             $("#deleteModal").addClass('hidden');
         this.isAdd=0;
         this.isEdit=0;
         this.isDelete=0;
         this.deleteId=0;
     },
     addModal(){
         this.packages={name:'',status:'Active'};
         if(!this.isAdd)
             $("#editModal").removeClass('hidden');
         else
             $("#editModal").addClass('hidden');
             $("#first_input").focus();
         this.isAdd=!this.isAdd;
     },
    
     editModal(item){
         if(item){
             let copy = JSON.parse(JSON.stringify(item));
             this.packages=copy;
            // console.log(this.packages);
         }
         if(!this.isEdit)
             $("#editModal").removeClass('hidden');
         else
             $("#editModal").addClass('hidden');
         this.isEdit=!this.isEdit;
     },
     
     deleteModal(id){
         this.deleteId=id;
         if(!this.isDelete)
             $("#deleteModal").removeClass('hidden');
         else
             $("#deleteModal").addClass('hidden');
         this.isDelete=!this.isDelete;
     },
     async getBasics() {
           var self=this;
             axios.post('getallpackage').then(function (response) {
                     self.packageList=response.data.packages;
                     self.employees=response.data.userDetails;
                    });
      },
      save_package() {
                 var self = this; 
                 axios.post('addPackage', this.packages)
                     .then(response => {
                         var msg = response.data.msg;
                         var isSuccess = response.data.status;
                        //  self.packageList=response.data.packages;
                        //  self.employees=response.data.userDetails;
                         self.getBasics();
                         self.closeModal();
                        //  self.cat={name:'',status:'Active'};
    
                         //self.$swal(msg);
                        //  if (isSuccess == 1) {
                        //      self.closeModal();
                        //  }
                     })
                     .catch(error => {
                         console.log('Error on Authentication: ' + error);
                     });
             },
             delete_category() {
                 var self = this; 
                 axios.post('deletepackage', {deleteId:this.deleteId})
                     .then(response => {
                        self.packageList=response.data.packages;
                        self.employees=response.data.userDetails;
                          self.closeModal(); 
                     })
                     .catch(error => {
                         console.log('Error on Authentication: ' + error);
                     });
             },
    }
    }
    </script>

